import { isCheckField, isPeriodField, isSearchField, isSelectField, TField } from '@/ui-kit/table-filters/filters.type';

export function useHasFilter(fields: Record<string, TField>) {
  const hasFilters = Object.keys(fields).reduce((prev, current) => {
    if (isPeriodField(fields[current])) {
      return prev || !!fields[current].value.from || !!fields[current].value.to;
    } else if (isSelectField(fields[current])) {
      return prev || !!fields[current].value.label || !!fields[current].value.value;
    } else if (isSearchField(fields[current])) {
      return prev || !!fields[current].value.value;
    } else if (isCheckField(fields[current])) {
      return prev || !!fields[current].values?.[0]?.value;
    } else {
      return prev || !!fields[current].value;
    }
  }, false);

  return hasFilters;
}
